import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {

  @Input() data: any;  // Receive message from parent
  @Input() isVisible: boolean = false;  // Control modal visibility from parent
  @Output() confirmEvent = new EventEmitter<boolean>(); // Emit result to parent

  confirm() {
    this.confirmEvent.emit(true);
  }

  cancel() {
    this.confirmEvent.emit(false);
  }
}
